'use strict';

// hoisted due to circular dependency on command.
var _slicedToArray = require("/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
module.exports = {
  applyMiddleware: applyMiddleware,
  commandMiddlewareFactory: commandMiddlewareFactory,
  globalMiddlewareFactory: globalMiddlewareFactory
};
var isPromise = require('./is-promise');
var argsert = require('./argsert');
function globalMiddlewareFactory(globalMiddleware, context) {
  return function (callback) {
    var applyBeforeValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    argsert('<array|function> [boolean]', [callback, applyBeforeValidation], arguments.length);
    if (Array.isArray(callback)) {
      for (var i = 0; i < callback.length; i++) {
        if (typeof callback[i] !== 'function') {
          throw Error('middleware must be a function');
        }
        callback[i].applyBeforeValidation = applyBeforeValidation;
      }
      Array.prototype.push.apply(globalMiddleware, callback);
    } else if (typeof callback === 'function') {
      callback.applyBeforeValidation = applyBeforeValidation;
      globalMiddleware.push(callback);
    }
    return context;
  };
}
function commandMiddlewareFactory(commandMiddleware) {
  if (!commandMiddleware) return [];
  return commandMiddleware.map(function (middleware) {
    middleware.applyBeforeValidation = false;
    return middleware;
  });
}
function applyMiddleware(argv, yargs, middlewares, beforeValidation) {
  var beforeValidationError = new Error('middleware cannot return a promise when applyBeforeValidation is true');
  return middlewares.reduce(function (accumulation, middleware) {
    if (middleware.applyBeforeValidation !== beforeValidation && !isPromise(accumulation)) {
      return accumulation;
    }
    if (isPromise(accumulation)) {
      return accumulation.then(function (initialObj) {
        return Promise.all([initialObj, middleware(initialObj, yargs)]);
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          initialObj = _ref2[0],
          middlewareObj = _ref2[1];
        return Object.assign(initialObj, middlewareObj);
      });
    } else {
      var result = middleware(argv, yargs);
      if (beforeValidation && isPromise(result)) throw beforeValidationError;
      return isPromise(result) ? result.then(function (middlewareObj) {
        return Object.assign(accumulation, middlewareObj);
      }) : Object.assign(accumulation, result);
    }
  }, argv);
}